import { Button, Center, Flex, Text, VStack } from '@chakra-ui/react'
import { useMe, usePracticeAccess } from '@hb/react'
import {
  FloatingContainer,
  PageContainer,
  PracticeContractsStatusProviderView,
  usePracticeContractsStatus,
} from '@hb/react-web'
import { colors } from '@hb/shared'
import { Link } from 'react-router-dom'

export const PracticeContractsView = () => {
  const { selectedPracticeId } = usePracticeAccess()
  const me = useMe()
  const status = usePracticeContractsStatus(selectedPracticeId, me?.uid ?? null)

  if (!selectedPracticeId) {
    return (
      <PageContainer>
        <Center w="100%">
          <FloatingContainer w="auto">
            <VStack spacing={0}>
              <Text fontFamily="Open Sans">No practice selected</Text>
              <Flex gap="0.3rem">
                <Text>Go to</Text>
                <Link to="/settings">
                  <Button color={colors.green.hex} variant="link">
                    Settings
                  </Button>
                </Link>
                <Text>to select a practice</Text>
              </Flex>
            </VStack>
          </FloatingContainer>
        </Center>
      </PageContainer>
    )
  }
  return (
    <PageContainer>
      <PracticeContractsStatusProviderView
        status={status}
        signerId={me?.uid ?? null}
        practiceId={selectedPracticeId}
      />
    </PageContainer>
  )
}
